import './css/base.css';

import { HelpAgentApp } from './components/help-agent-app';
import { HelpAgentComposer } from './components/help-agent-composer';
import { HelpAgentHeader } from './components/help-agent-header';
import { HelpAgentIcon } from './components/help-agent-icon';
import { HelpAgentImageGalleryModal } from './components/help-agent-image-gallery-modal';
import { HelpAgentMessageItem } from './components/help-agent-message-item';
import { HelpAgentMessageList } from './components/help-agent-message-list';
import { HelpAgentSessionInfo } from './components/help-agent-session-info';
import { HelpAgentToastStack } from './components/help-agent-toast-stack';

export { HelpAgentApp, HelpAgentIcon };

export function registerHelpAgentWidget(): void {
  if (typeof customElements === 'undefined') {
    return;
  }

  customElements.get('help-agent-icon') || HelpAgentIcon;
  customElements.get('help-agent-message-item') || HelpAgentMessageItem;
  customElements.get('help-agent-message-list') || HelpAgentMessageList;
  customElements.get('help-agent-session-info') || HelpAgentSessionInfo;
  customElements.get('help-agent-toast-stack') || HelpAgentToastStack;
  customElements.get('help-agent-image-gallery-modal') || HelpAgentImageGalleryModal;
  customElements.get('help-agent-header') || HelpAgentHeader;
  customElements.get('help-agent-composer') || HelpAgentComposer;
  customElements.get('help-agent-app') || HelpAgentApp;
}
